module.exports = __webpack_public_path__ + "img/block-768.d89de72a.jpg";